
import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings from "../appsettings";
import * as listbox     from "../listbox";
import * as main        from "../main";
import * as navigation  from "../navigation";
import * as tabstrip    from "../tabstrip";
import * as viewmode    from "../viewmode";
import * as grid        from "../grid";

let _msg_notsaved = "";

let LABEL_YES = "";
let LABEL_NO = "";
let LABEL_DELETE = "";
let LABEL_DELETE_APP = "";

let _isApplicationNode = false;

let oldDomainName = "";


export function tabStripInitialize(isApplicationNode: boolean): void {
    _isApplicationNode = isApplicationNode;
}


export function tabSSOInitialize(labelYes: string, labelNo: string, labelDelete: string, labelDeleteApp: string): void {

    // Create new record ...
    $(document)
        .off("click.overviewAdd", "#SubDomainGrid .k-grid-add")
        .on("click.overviewAdd", "#SubDomainGrid .k-grid-add", function (e: JQuery.Event): void {

        // Prevent default behaviour 
        e.preventDefault();

        main.setHideDiv("DivAddSubDomain", true);
        main.setHideDiv("DivUpdateSubDomain", false);
    });
    grid.loadGridOptions("SubDomainGrid");
    LABEL_YES = labelYes;
    LABEL_NO = labelNo;
    LABEL_DELETE = labelDelete;
    LABEL_DELETE_APP = labelDeleteApp;

    oldDomainName = "";

    main.setHideDiv("DivBtnRemoveApplication", _isApplicationNode);
}


export function onTabStripContentLoad(e: kendo.ui.TabStripContentLoadEvent): void {

    tabstrip.onContentLoad(e);

    if (!_isApplicationNode) {
        // hide tab identity providers
        const item = e.sender.items()[3] as HTMLElement;
        item.style.display = "none";
    }

    main.setHideDivBootstrap("divTabStripnodeconfiguration", true);
}

export function afterCreateApp(): void {
    _isApplicationNode = true;
    main.setHideDiv("DivBtnRemoveApplication", true);

    //$("#editTabstripNodeConfigOverview").data("kendoTabStrip").items()[3].hidden = false;

    const tabStrip = $("#editTabstripNodeConfigOverview").data("kendoTabStrip");
    // Show the fourth tab (index 3)
    tabStrip.tabGroup.children().eq(3).show();
}

export function afterDeleteApp(): void {
    _isApplicationNode = false;
    main.setHideDiv("DivBtnRemoveApplication", false);

    const tabStrip = $("#editTabstripNodeConfigOverview").data("kendoTabStrip");
    // Hide the fourth tab (index 3)
    tabStrip.tabGroup.children().eq(3).hide();
}

export function onRemoveAppClicked(): void {

    main.openActionsDialog(' ', LABEL_DELETE_APP,
        [{ text: LABEL_YES, action: function () { removeApp(); main.closePopup(); } },
        { text: LABEL_NO, action: function () { main.closePopup(); } }]);
}

export function removeApp(): void {

    const actionUrl = "NodeConfig/DeleteApplication";

    $.ajax({
        type: "POST",
        url: appsettings.getUrl(actionUrl),
        success: function (responseData) {

            if (responseData != undefined && responseData != null) {

                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                } else {
                    afterDeleteApp();
                }
            }
        }
    });
}

export function editSubDomain(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    main.setHideDiv("DivUpdateSubDomain", true);
    main.setHideDiv("DivAddSubDomain", false);

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as { DomainName: string };

    const tb = $("#tbUpdateSubDomain").data("kendoTextBox");
    tb.value(dataItem.DomainName);
    oldDomainName = dataItem.DomainName;
}

export function updateSubDomain(): void {

    const tb = $("#tbUpdateSubDomain").data("kendoTextBox");

    if (tb != undefined && tb != null) {

        const actionUrl = "NodeConfig/UpdateSubDomain";

        $.ajax({
            type: "POST",
            url: appsettings.getUrl(actionUrl),
            data: { oldDomainName: oldDomainName, newDomainName: tb.value() },
            success: function (responseData) {

                if (responseData != undefined && responseData != null) {

                    if (responseData.Succesfully == false) {
                        main.openActionsDialog(' ', responseData.Message,
                            [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    } else {
                        main.setHideDiv("DivUpdateSubDomain", false);
                        $("#SubDomainGrid").data("kendoGrid").dataSource.read();
                    }
                }
            }
        });
    }
}

export function cancelUpdateSubDomain(): void {
    $("#tbUpdateSubDomain").data("kendoTextBox").value("");
    main.setHideDiv("DivUpdateSubDomain", false);
}

export function deleteSubDomain(e: any): void {

    const event = e;
    const data = this;

    const dataItem = data.dataItem($(event.currentTarget).closest("tr"));

    main.openActionsDialog(' ', LABEL_DELETE,
        [{ text: LABEL_YES, action: function () { removeSubDomain(dataItem.DomainName); main.closePopup(); } },
        { text: LABEL_NO, action: function () { main.closePopup(); } }]);
}

export function removeSubDomain(domainName: string): void {

    const actionUrl = "NodeConfig/DeleteSubDomain";

    $.ajax({
        type: "POST",
        url: appsettings.getUrl(actionUrl),
        data: { domainName: domainName },
        success: function (responseData) {

            if (responseData != undefined && responseData != null) {

                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            $("#SubDomainGrid").data("kendoGrid").dataSource.read();
        }
    });

}

export function addNewSubDomain(): void {

    const tb = $("#tbNewSubDomain").data("kendoTextBox");

    if (tb != undefined && tb != null) {

        const actionUrl = "NodeConfig/AddSubDomain";

        $.ajax({
            type: "POST",
            url: appsettings.getUrl(actionUrl),
            data: { newDomainName: tb.value() },
            success: function (responseData) {

                if (responseData != undefined && responseData != null) {

                    if (responseData.Succesfully == false) {
                        main.openActionsDialog(' ', responseData.Message,
                            [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                    } else {
                        main.setHideDiv("DivAddSubDomain", false);
                        $("#SubDomainGrid").data("kendoGrid").dataSource.read();
                    }
                }
            }
        });
    }
}

export function cancelNewSubDomain(): void {
    $("#tbNewSubDomain").data("kendoTextBox").value("");
    $("#lblError").text("");
    main.setHideDiv("DivAddSubDomain", false);
}


export function tabIpInitialize(labelYes: string, labelNo: string, labelDelete: string): void {

    // Create new record ...
    $(document)
        .off("click.overviewAdd", "#IdProGrid .k-grid-add")
        .on("click.overviewAdd", "#IdProGrid .k-grid-add", function (e: JQuery.Event): void {

        // Prevent default behaviour 
        e.preventDefault();

        // Load create form into the current module div
        navigation.navigateToSpecificUrl("NodeConfig/AddIdentityProvider");
    });
    grid.loadGridOptions("IdProGrid");
    LABEL_YES = labelYes;
    LABEL_NO = labelNo;
    LABEL_DELETE = labelDelete;
}

export function onSelectCertificate(e: kendo.ui.UploadSelectEvent): void {
    $.each(e.files, function (index, value) {
        readMultipleFiles_KendoUploadWidget(value, "#Certificate");
    });
}

export function onSelectLocalCertificate(e: kendo.ui.UploadSelectEvent): void {
    $.each(e.files, function (index, value) {
        readMultipleFiles_KendoUploadWidget(value, "#LocalCertificate");
    });
}

export function readMultipleFiles_KendoUploadWidget(file: any, control: string): void {
    const reader = new FileReader();

    reader.onload = function (): void {
        $(control).val((reader.result as string) ?? "");
    }

    reader.readAsDataURL(file.rawFile);
}

export function showIdPro(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as IdProGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("NodeConfig/EditIdentityProvider?identityProviderId=" + dataItem.IdentityProviderID + "&breadcrumbLabel=" + dataItem.Label);
}

export function editIdPro(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    // Set mode 
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as IdProGridVM;

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("NodeConfig/EditIdentityProvider?identityProviderId=" + dataItem.IdentityProviderID + "&breadcrumbLabel=" + dataItem.Label);
}

export function deleteIdPro(e: JQuery.Event & { currentTarget: HTMLElement }): void {
    const event = e;
    const data = this;

    const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as IdProGridVM;

    main.openActionsDialog(' ', LABEL_DELETE,
        [{ text: LABEL_YES, action: function () { removeIdPro(dataItem.IdentityProviderID); main.closePopup(); } },
        { text: LABEL_NO, action: function () { main.closePopup(); } }]);
}

export function removeIdPro(id: number): void {

    const actionUrl = "NodeConfig/DeleteIdentityProvider";

    $.ajax({
        type: "POST",
        url: appsettings.getUrl(actionUrl),
        data: { identityProviderId: id },
        success: function (responseData) {

            if (responseData != undefined && responseData != null) {

                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            $("#IdProGrid").data("kendoGrid").dataSource.read();
        }
    });
}


/* TAB_Modules */

/**
* 
*/
export function tabModulesInitialize(notsaved: string): void {
    _msg_notsaved = notsaved;
}

/**
* Return label changed not saved
*/
export function tabModulesGetLDataChangedNotSavedYet(): string {
    return _msg_notsaved;
}

/**
* Move user to the left
*/
export function tabModulesLeftClicked(): void {
    tabModulesEnableSaveButton();
    listbox.moveItems("NodeConfiguration_Modules_CplSelected", "NodeConfiguration_Modules_CplNotSelected", "#Modules_Validation", tabModulesGetLDataChangedNotSavedYet());
}

/**
* Move user to the right
*/
export function tabModulesRightClicked(): void {
    tabModulesEnableSaveButton();
    listbox.moveItems("NodeConfiguration_Modules_CplNotSelected", "NodeConfiguration_Modules_CplSelected", "#Modules_Validation", tabModulesGetLDataChangedNotSavedYet());
}

/**
* Enable save button
*/
export function tabModulesEnableSaveButton(): void {
    const btnSave = document.getElementById("saveButtonModules");
    btnSave.removeAttribute("disabled");
}

/**
* Save button clicked
*/
export function tabModulesSaveButtonClicked(actionUrl: string): void {

    const json = $("#NodeConfiguration_Modules_CplSelected").data("kendoListBox").dataSource.view().toJSON();
    const list = json.slice();

    $.ajax({
        type: "POST",
        url: appsettings.getUrl(actionUrl),
        data: { list: kendo.stringify(list) },
        success: function (responseData) {

            $('#Modules_Validation').text("");

            const tabStrip = $("#editTabstripNodeConfigOverview").data("kendoTabStrip");
            const tab = tabStrip.select();
            tabStrip.reload(tab);

            const color = (responseData.Succesfully ? 'green' : 'red');
            $('#Modules_Validation').text(responseData.Message);
            $('#Modules_Validation').attr('style', 'color:' + color);
        }
    });
}

/**
* Get Occupancy for the left and right.
*/
export function tabModulesGetOccupancy(): void {
    $("#TableModules").load(appsettings.getUrl("NodeConfig/GetModules"));
}

export function onChangeIdentityProviderTypeID(): void {
        setHideTypeFields(this.value());
}

export function setHideTypeFields(selectedType: string): void {
    main.setHideDivBootstrap("divSAML", false);
    main.setHideDivBootstrap("divOAuth", false);

    switch (selectedType) {
        case "1":
            main.setHideDivBootstrap("divSAML", true);
            break;
        case "2":
            main.setHideDivBootstrap("divOAuth", true);
            break;
    }
}
